import React from "react";
import EyeNoData from "../../../components/Nav & Header/Eye";

function NoFavorites() {
  function handleClick() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  return (
    <div className="mt-[50px] lg:mt-[100px] mb-[200px] md:gap-y-[0px] lg:gap-y-[40px] flex flex-col items-center justify-center w-full">
      <div className="nodatazoom">
        <EyeNoData />
      </div>
      <div className="space-y-6 max-w-[350px] text-center text-tertiary ">
        <p className="text-[14px] sm:text-[16px] capitalize font-SoraL">
          You Don't Have Any Novels Yet To Display! Start Adding Yours Now.
        </p>
        <div className="flex justify-center items-center scale-90">
          <div
            className="w-0 h-0 
   border-l-[10px] border-l-transparent
   border-t-[10px] border-t-primary
   border-r-[10px] border-r-transparent
   "
          ></div>
        </div>
        {/* <button > */}
        <div
          onClick={handleClick}
          className=" cursor-pointer flex justify-center items-center"
        >
          <div className="Purple-btn-effect flex justify-center items-center font-SoraR hover:bg-primary/90 duration-500 ease-in-out w-[163px] h-[52px] bg-primary relative z-10 text-tertiary">
            Create Now
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoFavorites;
